/**
 *  Supported colors in the Palette
 */
// eslint-disable-next-line no-restricted-syntax
export enum PaletteColor {
	BLUE = 'BLUE',
	DARK_BLUE = 'DARK_BLUE',
	DARK_GREEN = 'DARK_GREEN',
	DARK_GREY = 'DARK_GREY',
	DARK_ORANGE = 'DARK_ORANGE',
	DARK_PURPLE = 'DARK_PURPLE',
	DARK_TEAL = 'DARK_TEAL',
	DARK_YELLOW = 'DARK_YELLOW',
	GREEN = 'GREEN',
	GREY = 'GREY',
	ORANGE = 'ORANGE',
	PURPLE = 'PURPLE',
	TEAL = 'TEAL',
	YELLOW = 'YELLOW',
}
